export const ABOUT_SHOW_TOGGLE_LOADING = 'ABOUT_SHOW_TOGGLE_LOADING'
export const ABOUT_SHOW_SET_ERROR = 'ABOUT_SHOW_SET_ERROR'
export const ABOUT_SHOW_RESET = 'ABOUT_SHOW_RESET'
export const ABOUT_SET_STATS = 'ABOUT_SET_STATS'
